import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { ICompany } from 'app/shared/model/company.model';
import { getEntities as getCompanies } from 'app/entities/company/company.reducer';
import { IVehiclePosition } from 'app/shared/model/vehicle-position.model';
import { getEntities as getVehiclePositions } from 'app/entities/vehicle-position/vehicle-position.reducer';
import { getEntity, updateEntity, createEntity, reset } from './fifth-wheel-connection.reducer';
import { IFifthWheelConnection } from 'app/shared/model/fifth-wheel-connection.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const FifthWheelConnectionUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  const companies = useAppSelector(state => state.company.entities);
  const vehiclePositions = useAppSelector(state => state.vehiclePosition.entities);
  const fifthWheelConnectionEntity = useAppSelector(state => state.fifthWheelConnection.entity);
  const loading = useAppSelector(state => state.fifthWheelConnection.loading);
  const updating = useAppSelector(state => state.fifthWheelConnection.updating);
  const updateSuccess = useAppSelector(state => state.fifthWheelConnection.updateSuccess);

  const handleClose = () => {
    props.history.push('/fifth-wheel-connection' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getTruckImplements({}));
    dispatch(getCompanies({}));
    dispatch(getVehiclePositions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.created = convertDateTimeToServer(values.created);

    const entity = {
      ...fifthWheelConnectionEntity,
      ...values,
      vehicle: truckImplements.find(it => it.id.toString() === values.vehicleId.toString()),
      trailer: truckImplements.find(it => it.id.toString() === values.trailerId.toString()),
      company: companies.find(it => it.id.toString() === values.companyId.toString()),
      vehiclePosition: vehiclePositions.find(it => it.id.toString() === values.vehiclePositionId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          created: displayDefaultDateTime(),
        }
      : {
          ...fifthWheelConnectionEntity,
          created: convertDateTimeFromServer(fifthWheelConnectionEntity.created),
          vehicleId: fifthWheelConnectionEntity?.vehicle?.id,
          trailerId: fifthWheelConnectionEntity?.trailer?.id,
          companyId: fifthWheelConnectionEntity?.company?.id,
          vehiclePositionId: fifthWheelConnectionEntity?.vehiclePosition?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.fifthWheelConnection.home.createOrEditLabel" data-cy="FifthWheelConnectionCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.fifthWheelConnection.home.createOrEditLabel">Create or edit a FifthWheelConnection</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="fifth-wheel-connection-id" label={translate('global.field.id')} validate={{ required: true }} />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.fifthWheelConnection.created')}
                id="fifth-wheel-connection-created"
                name="created"
                data-cy="created"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fleetSenseApp.fifthWheelConnection.installVehicleOdometer')}
                id="fifth-wheel-connection-installVehicleOdometer"
                name="installVehicleOdometer"
                data-cy="installVehicleOdometer"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.fifthWheelConnection.installTrailerOdometer')}
                id="fifth-wheel-connection-installTrailerOdometer"
                name="installTrailerOdometer"
                data-cy="installTrailerOdometer"
                type="text"
              />
              <ValidatedField
                id="fifth-wheel-connection-vehicle"
                name="vehicleId"
                data-cy="vehicle"
                label={translate('fleetSenseApp.fifthWheelConnection.vehicle')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.licensePlate}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="fifth-wheel-connection-trailer"
                name="trailerId"
                data-cy="trailer"
                label={translate('fleetSenseApp.fifthWheelConnection.trailer')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.licensePlate}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="fifth-wheel-connection-company"
                name="companyId"
                data-cy="company"
                label={translate('fleetSenseApp.fifthWheelConnection.company')}
                type="select"
              >
                <option value="" key="0" />
                {companies
                  ? companies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="fifth-wheel-connection-vehiclePosition"
                name="vehiclePositionId"
                data-cy="vehiclePosition"
                label={translate('fleetSenseApp.fifthWheelConnection.vehiclePosition')}
                type="select"
              >
                <option value="" key="0" />
                {vehiclePositions
                  ? vehiclePositions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/fifth-wheel-connection" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FifthWheelConnectionUpdate;
